var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAdultLabel = function SvgIconAdultLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.379 2.497a.994.994 0 0 1 1.242 0 24.862 24.862 0 0 0 5.434 3.305l2.14.951a.86.86 0 0 1 .508.853l-.507 6.517a6.25 6.25 0 0 1-3.098 4.924l-4.471 2.59a1.25 1.25 0 0 1-1.254 0l-4.47-2.59a6.25 6.25 0 0 1-3.1-4.924l-.506-6.517a.86.86 0 0 1 .508-.853l2.14-.95a24.863 24.863 0 0 0 5.434-3.306Z",
    fill: "#FF970C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon_adult_label_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 19,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37 7.215a1.111 1.111 0 0 1 .841-1.214L5.75 5.63c1.653-.4 3.217-1.1 4.616-2.067l1.573-1.088c.413-.285.96-.285 1.372 0l1.573 1.088A13.842 13.842 0 0 0 19.5 5.629l1.539.372c.548.133.91.655.842 1.214l-.813 6.687a5 5 0 0 1-2.653 3.83l-5.148 2.684a1.39 1.39 0 0 1-1.284 0l-3.42-1.783-1.728-.9a5 5 0 0 1-2.653-3.83L3.37 7.214Z",
    fill: "#FF970C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_adult_label_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.943 12.305c1.381 0 2.5-1.1 2.5-2.455 0-1.356-1.119-2.454-2.5-2.454-1.38 0-2.5 1.098-2.5 2.454s1.12 2.455 2.5 2.455Zm4.674 3.59c.473.431.287 1.153-.268 1.473l-3.78 2.184a1.25 1.25 0 0 1-1.251 0l-3.78-2.184c-.555-.32-.741-1.041-.268-1.473 1.282-1.172 2.906-1.872 4.674-1.872 1.767 0 3.391.7 4.673 1.872Zm-3.946 5.304 1.103-.607c1.726-.951 3.06.338 1.311 1.249a6.851 6.851 0 0 1-3.142.773 6.851 6.851 0 0 1-3.14-.773c-1.749-.91-.416-2.2 1.31-1.249l1.103.607c.452.25 1.003.25 1.455 0Z",
    fill: "#fff"
  }))));
};
export default SvgIconAdultLabel;